import React from 'react';
import { SxProps } from '@cp/ds';
import { GeoPoint } from '@common/model/location/geopoint';
import { Map as LegacyMap } from 'src/app/shared/components/map/index';
import { MapHandle, MapInstance, MapMarkerConfig } from 'src/app/shared/components/map/model';
export type { MapHandle, MapMarkerConfig, MapInstance } from 'src/app/shared/components/map/model';

export interface MapProps {
  sx?: SxProps;
  onMapCreated?: (mapInstance: MapInstance) => void;
  onMapDestroy?: () => void;
  onClose?: () => void;
  center?: GeoPoint;
  zoom?: number;
  zoomControl?: boolean;
  fullscreenControl?: boolean;
  markers?: MapMarkerConfig[];
  fallback?: React.ReactNode;
}

export const Map = React.forwardRef<MapHandle, MapProps>(({ center, ...props }, ref) => (
  <LegacyMap center={center?.toString()} ref={ref} {...props} />
));
